// extracted by mini-css-extract-plugin
module.exports = {"container":"Ou","copy":"Pu","field":"Qu","error":"Ru","disabled":"Su","termsContainer":"Tu","termsHeading":"Uu","termsCopy":"Vu","submit":"Wu","srOnly":"Xu"};